// @ts-check
/* CUSTOM: Burgermenu på mobil (11/10 2026). Indlæses af snippets/custom-mobile-menu.
   1. Menuen starter under headeren, så logo, burger og kurv kan ses, mens den er åben.
      Placeringen måles i det øjeblik, burgeren trykkes (headeren er sticky og kan have
      announcement-baren over sig). CSS: --custom-nav-drawer-top i assets/custom-mobile-menu.css.
   2. Tryk på et andet ikon i headeren (søg, kurv) lukker menuen først – ellers lå den åben under
      kurven/søgningen. Burgeren selv lukker allerede menuen (Motions klik-udenfor).
   (Gruppe nr. 2 og frem som eget topniveau-punkt laves siden 16/10 2026 i Liquid – snippets/custom-mobile-menu, area 'groups'.) */
(function () {
  const MOBILE = window.matchMedia('(max-width: 1023px)');

  /**
   * Hvor menuen skal starte (px fra toppen af skærmen). Lige under headeren, når hele headeren kan ses –
   * ellers 0 (fuld skærm med menuens eget luk-kryds, fx hvis man har scrollet lidt, før headeren bliver sticky).
   * @param {number} headerTop Headerens overkant i px fra toppen af skærmen
   * @param {number} headerBottom Headerens underkant i px fra toppen af skærmen
   * @param {number} viewportHeight Skærmens højde i px
   * @returns {number}
   */
  function getDrawerTop(headerTop, headerBottom, viewportHeight) {
    if (headerTop < 0 || !(headerBottom > 0) || headerBottom > viewportHeight / 2) return 0;
    // floor (ikke round): headerens højde er ofte et kommatal (fx 109,6px). Afrundet op opstod en sprække under 1px,
    // hvor billedet bag menuen skinnede igennem som en tyk, mønstret streg over SMYKKER (iPhone, 13/10 2026).
    // Rundet ned overlapper menuen headerens underkant en anelse i stedet.
    return Math.floor(headerBottom);
  }

  /** @returns {HTMLElement | null} */
  function getDrawer() {
    return document.getElementById('NavDrawer');
  }

  function placeDrawer() {
    const drawer = getDrawer();
    const header = document.querySelector('.site-header');
    if (!drawer || !header) return;

    const rect = header.getBoundingClientRect();
    const top = MOBILE.matches ? getDrawerTop(rect.top, rect.bottom, window.innerHeight) : 0;
    drawer.style.setProperty('--custom-nav-drawer-top', top + 'px');
    drawer.classList.toggle('custom-nav-drawer--under-header', top > 0);
  }

  function closeDrawer() {
    const drawer = getDrawer();
    if (!drawer || !drawer.classList.contains('drawer--is-open')) return;
    const closeButton = drawer.querySelector('.js-drawer-close');
    if (closeButton instanceof HTMLElement) closeButton.click();
  }

  // Capture-fase: kører før Motions egne klik-handlere
  document.addEventListener('click', function (event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const burger = target.closest('.js-drawer-open-nav');
    if (burger) {
      placeDrawer();
      return;
    }

    if (target.closest('.site-header :is(.js-search-header, .js-drawer-open-cart)')) {
      closeDrawer();
    }
  }, true);



  // @ts-ignore – til isoleret test i konsollen
  window.CustomMobileMenu = { getDrawerTop: getDrawerTop };
})();
